import { classNames } from "primereact";
import { Timestamp } from "firebase/firestore";
import { maxBy } from "lodash";
import { observer } from "mobx-react";
import moment from "moment";
import { Card } from "primereact/card";
import {
  IncidentStatus,
  Incident,
} from "../../api/firebase/types/incident.types";
import { screenSize, useMediaQuery } from "../../hooks/responsiveLayout";

type IncidentOverviewCardProps = {
  incidents?: Incident[];
};

const IncidentOverviewCard: React.FC<IncidentOverviewCardProps> = (props) => {
  const [width] = useMediaQuery();

  const latestIncident = maxBy(
    props.incidents,
    (incident) => incident.created?.seconds
  );

  const failedIncidents = props.incidents?.filter((incident) => {
    if (!incident.status) return false;
    return (incident.status as IncidentStatus) === IncidentStatus.FAILED;
  });

  const timestampToDateString = (timestamp?: Timestamp) => {
    if (!timestamp) return "Keine Alarme vorhanden";
    return moment(timestamp.toDate()).format("DD.MM.yyyy HH:mm");
  };

  const infoCardElems: Record<string, any> = {
    "Letzter Alarm: ": timestampToDateString(latestIncident?.created) + " Uhr",
    "Alarme gesamt: ": props.incidents?.length,
    "Fehlgeschlagene Alarme: ": failedIncidents?.length || "Keine",
  };

  return (
    <Card
      className={classNames("homeview-info-card p-col p-mb-2", {
        "p-mr-2": width >= screenSize.phone,
      })}
    >
      <table>
        <tbody>
          {Object.entries(infoCardElems).map(([key, value]) => (
            <tr key={key}>
              <td>
                <b>{key}</b>
              </td>
              <td className="homeview-info-value">{value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Card>
  );
};

export default observer(IncidentOverviewCard);
